import { cn } from "@circleco/community-switcher/helpers/cn";
import { useCommunitySwitcherContext } from "@circleco/community-switcher/context/CommunitySwitcherContext";

interface CommunityNotificationsBadgeProps {
  readonly notificationCount: number;
}

export const CommunityNotificationsBadge = ({
  notificationCount,
}: CommunityNotificationsBadgeProps) => {
  const { backgroundColor } = useCommunitySwitcherContext();

  if (notificationCount <= 0) return null;
  return (
    <span
      aria-hidden
      className={cn(
        "absolute right-0 top-0 flex size-3 items-center rounded-full border-2 bg-red-500",
      )}
      style={{
        borderColor:
          backgroundColor ||
          "var(--color-community-switcher-background, #FFFFFF)",
      }}
    />
  );
};
